import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import "../SignIn/Styles.css"; // Assuming basic styling from SignIn

const API_URL = process.env.NODE_ENV === 'development' ? '' : (process.env.REACT_APP_API_URL || 'https://ceindiazone2.in');

const ResetPassword = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    // Attempt to get token and email from URL parameters
    const token = searchParams.get("token");
    const email = searchParams.get("email");

    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);

    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setMessage("");

        if (!token || !email) {
            setMessage("Invalid reset link. Missing token or email.");
            return;
        }

        if (newPassword !== confirmPassword) {
            setMessage("Passwords do not match.");
            return;
        }

        setIsLoading(true);
        try {
            const res = await fetch(`${API_URL}/api/auth/reset-password`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    email: email,
                    token: token,
                    newPassword: newPassword
                }),
            });

            const data = await res.text();

            if (res.ok) {
                setIsSuccess(true);
                setMessage("Password reset successfully! Please check your email for confirmation, and sign in again.");
                setTimeout(() => {
                    navigate("/signIn");
                }, 4000);
            } else {
                if (data.toLowerCase().includes("expired") || data.toLowerCase().includes("invalid")) {
                    setMessage("Token expired or password already updated. Please try signing in.");
                } else {
                    setMessage(data || "Failed to reset password. Please try again.");
                }
            }
        } catch (err) {
            console.error("Reset failed", err);
            setMessage("An error occurred. Please try again later.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="signin-container">
            <div className="signin-left">
                <div className="signin-left-content">
                    <h1>Reset Password</h1>
                    <p>Create a new strong password for your account.</p>
                </div>
            </div>

            <div className="signin-right">
                <h2>Create New Password</h2>
                <form onSubmit={handleResetPassword}>
                    <div className="form-group">
                        <input
                            type={showNewPassword ? "text" : "password"}
                            placeholder="New Password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                        />
                        <button
                            type="button"
                            className="password-toggle-btn"
                            onClick={() => setShowNewPassword(!showNewPassword)}
                        >
                            {showNewPassword ? "🙈" : "👁️"}
                        </button>
                    </div>
                    <div className="form-group">
                        <input
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Confirm New Password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                        <button
                            type="button"
                            className="password-toggle-btn"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        >
                            {showConfirmPassword ? "🙈" : "👁️"}
                        </button>
                    </div>
                    <button type="submit" className="login-btn" disabled={isSuccess || isLoading}>
                        {isSuccess ? "Redirecting..." : isLoading ? "Updating..." : "Update Password"}
                    </button>
                </form>

                {message && (
                    <p style={{ marginTop: "1rem", textAlign: "center", color: isSuccess ? "#28a745" : "red" }}>
                        {message}
                    </p>
                )}

                <p className="or-text">
                    Back to <span> <Link to="/signIn" className="toggle-btn">Sign In</Link></span>
                </p>
            </div>
        </div>
    );
};

export default ResetPassword;
